module.exports = __webpack_public_path__ + "media/application/images/2018/2018-member-lock-c1ada1c3123fce10bde0f687f16fb9e2.svg";